document.addEventListener('click', e => {
    const btn = e.target.closest('[data-spcoll]');
    if (btn) {
      const wrapper = btn.closest('.spcoll_wrapper');
      wrapper.querySelectorAll('.spcoll').forEach(el => {
        const isActive = (`#${el.id}` === btn.dataset.spcoll);
        el.classList.toggle('spcoll_open', isActive && !el.classList.contains('spcoll_open'));
      });
      wrapper.querySelectorAll('[data-spcoll]').forEach(b => {
        b.classList.toggle('spcoll_active', (`#${wrapper.querySelector('.spcoll.spcoll_open')?.id}` === b.dataset.spcoll));
      });

      document.dispatchEvent(new CustomEvent('spcoll:changed', {
        detail: {
          button: btn,
          wrapper: wrapper,
          activeContent: wrapper.querySelector('.spcoll.spcoll_open')
        }
      }));
    }
});